import { useCreateEvent } from "@/features/events/hooks/useCreateEvent";
import { EventType } from "@/features/events/types/EventType";
import { confirmForgotPasswordApi } from "@/utils/apis/auth-service";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export const useNewPassword = () => {
    const navigate = useNavigate()
    const { sendEvent } = useCreateEvent();
    const location = useLocation();
    const email = location.state?.email as string;
    const code = location.state?.code as string;

    const [isLoading, setIsLoading] = useState(false);

    const onBackButtonClick = async () => {
        navigate("/forgot-password-insert-code", { state: { email } })
        await sendEvent({
            event: EventType.BUTTON_CLICK,
            sub_category: "back_button",
        });
    }

    const handleInputsSubmit = async (inputData: { [key: string]: string }) => {
            setIsLoading(true)
            const password = inputData.password
            await sendEvent({
                event: EventType.BUTTON_CLICK,
                sub_category: "submit_button",
                event_metadata: { action: "change_password", email },
            });
    
            confirmForgotPasswordApi(
                email,
                password,
                code,
                async () => {
                    setIsLoading(false)
                    navigate("/change-password-success", { state: { email, password } })
                    await sendEvent({
                        event: EventType.CHANGE_PASSWORD_SUCCESS,
                        sub_category: "change_password",
                        event_metadata: { email },
                    });
                },
                async (error) => {
                    setIsLoading(false)
                    await sendEvent({
                        event: EventType.CHANGE_PASSWORD_FAILED,
                        sub_category: "change_password",
                        event_metadata: { email, error },
                    });
                }
            )
        }

    return {
        onBackButtonClick,
        handleInputsSubmit,
        isLoading,
    }
}